import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ChangedParametersListModalComponentV2 from './ChangedParameterListComponentV2';
import { getModel } from './selectors';
import * as changedParametersListActions from './actions';
import { setSelectedNotification } from '../../../../PowertrainOverview/Header/NotificationDropdown/actions';


const ChangedParameterListModalContainer = (props) => {
	return <ChangedParametersListModalComponentV2 {...props} />;
};

export const mapStateToProps = (state) => {
	const model = getModel(state);
	return { model };
};

export const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators({ ...changedParametersListActions, setSelectedNotification }, dispatch)
	};
};

const ChangedParametersListContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(ChangedParameterListModalContainer);

export default ChangedParametersListContainerConn;
